// extracted by mini-css-extract-plugin
export default {"note":"askFilledNote_note__hnpdD"};